const isValidFloat = (value) => !Number.isNaN( Number.parseFloat(value));

export default isValidFloat;